<template>
    <!-- SDV Outcomes modal -->
    <div class="modal_wrapper">
        <div class="modal-container">
            <div class="titleclass">
                <h4 class="px-3 mt-1">{{ $t("navigations.sdv outcomes") }}</h4>
                <div class="closebutton mt-1">
                    <a style="color: white" class="close-link">
                        <i class="fa fa-times" @click.prevent="closemodal()"></i>
                    </a>
                </div>
            </div>
            <div class="modelbody p-0">
                <div class="mb-3 p-2">
                    <div class="form-group">
                        <div class="d-flex flex-column flex-lg-row">
                            <div class="col-lg-12 my-2">
                                <select class="form-control" placeholder="Select SDV Outcome" v-model="sdvOutcome">
                                    <option value="" disabled selected>
                                        {{ $t("navigations.select") }}
                                    </option>
                                    <option v-for="outcome in sdvOutcomesList" :key="outcome.statusId" :value="outcome.status">
                                        {{ outcome.status }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-12 my-2">
                            <textarea class="form-control" v-model="comments" rows="3" placeholder="Enter comments"></textarea>
                        </div>
                        <div class="d-flex justify-content-center my-3">
                            <button @click.prevent="saveSDVOutcome()" class="save_btn py-1 px-4 position-relative">
                                <div class="toc-loader position-absolute"
                                    :class="{ 'opacity-0': loadingBlock == false, 'opacity-1': loadingBlock == true }">
                                    <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
                                </div>
                                <div :class="{ 'opacity-1': loadingBlock == false, 'opacity-0': loadingBlock == true }">{{
                                    $t("navigations.verify") }}</div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of SDV Outcomes modal -->
</template>
<script src="./ChangesdvVerification.js"></script>
<style scoped>
.modal_wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}
.modal-container {
  background: #fff;
  width: min(50%, 90%);
  border-radius: 4px;
  position: fixed;
  transition: all 0.3s ease-in-out;
  height: auto !important;
  margin-top: 200px;
}
.modelbody {
  overflow: unset !important;
}
.opacity-05 {
  opacity: 0.5;
}

.opacity-0 {
  opacity: 0;
}

.opacity-1 {
  opacity: 1;
}
</style>
